import { render, staticRenderFns } from "./inboundgoods.vue?vue&type=template&id=21680f95&scoped=true&"
import script from "./inboundgoods.vue?vue&type=script&lang=js&"
export * from "./inboundgoods.vue?vue&type=script&lang=js&"
import style0 from "./inboundgoods.vue?vue&type=style&index=0&id=21680f95&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21680f95",
  null
  
)

export default component.exports